import { useQueryClient, useIsMutating as useIsMutatingReactQuery } from 'react-query'
import { MutationFilters } from 'react-query/types/core/utils'

export const useIsMutating = (filters?: MutationFilters) => {
  useIsMutatingReactQuery(filters)
  const queryClient = useQueryClient()
  return queryClient.isMutating(filters)
}
